import React from "react"
import { Link } from "react-router-dom"

export default function CookiePreferences() {
  return (
    <>
      <section className="bg-blue">
        <div className="px-5 py-10 md:pt-40 lg:max-w-4xl lg:mx-auto">
          <h4 className="text-white text-3xl md:text-4xl mb-5">
            Privacy preference centre
          </h4>
          <p className="text-white mb-3">
            When you visit any website, it may store or retrieve information on
            your browser, mostly in the form of cookies. This information might
            be about you, your preferences, your device, and is mostly used to
            make the site work as you expect it to. The information does not
            usually directly identify you, but it can give you a more
            personalised web experience.
          </p>
          <p className="text-white">
            As we respect your right to privacy, you can choose not to allow
            some types of cookies. Select the different category headings to
            find out more and change our default settings. Note that blocking
            some types of cookies may impact your experience of the site and the
            services we are able to offer.
          </p>

          <h4 className="text-white text-3xl mt-10 mb-5">
            Manage consent preferences
          </h4>
          <ul className="grid grid-cols-1 gap-10">
            <li>
              <div className="mb-5 flex items-center justify-between">
                <h5 className="text-white text-xl md:text-2xl">
                  Strictly Necessary Cookies
                </h5>
                <p className="text-gray-800 text-base">Always active</p>
              </div>
              <p className="text-white">
                These cookies are necessary for the website to function and
                cannot be switched off in our system. They are usually only set
                in response to actions made by you that amount to a request for
                services, such as setting your privacy preferences in filling
                forms. You can set your browser to block or alert you about
                these cookies, but some parts of the site will not then work.
                These cookies do not store any personally identifiable
                information.{" "}
              </p>
            </li>
            <li>
              <div className="mb-5 flex items-center justify-between">
                <h5 className="text-white text-xl md:text-2xl">
                  Performance Cookies
                </h5>
                {/* Toggle button */}
                <div class="toggle">
                  <input type="checkbox" class="checkbox" id="checkbox-1" />

                  <label for="checkbox-1" class="label">
                    <div class="ball"></div>
                  </label>
                </div>
                {/* End of toggle button  */}
              </div>
              <p className="text-white">
                These cookies allow us to count visits and traffic sources, so
                we can measure and improve the performance of our site. They
                help us know which pages are the most and least popular and how
                visitors move around the site. All information these cookies
                collect is aggregated and therefore anonymous. If you don't
                allow these cookies, we will not know when you have visited our
                site.
              </p>
            </li>
            <li>
              <div className="mb-5 flex items-center justify-between">
                <h5 className="text-white text-xl md:text-2xl">
                  Functional Cookies
                </h5>
                {/* Toggle button */}
                <div class="toggle">
                  <input type="checkbox" class="checkbox" id="checkbox-2" />

                  <label for="checkbox-2" class="label">
                    <div class="ball"></div>
                  </label>
                </div>
                {/* End of toggle button  */}
              </div>
              <p className="text-white">
                These cookies enable the website to provide enhanced
                functionality and personalisation. They may be set by us or by
                third-party providers whose services we have added to our pages.
                If you do not allow these cookies then some or all of these
                services may not function properly.
              </p>
            </li>
            <li>
              <div className="mb-5 flex items-center justify-between">
                <h5 className="text-white text-xl md:text-2xl">
                  Targeting Cookes
                </h5>
                {/* Toggle button */}
                <div class="toggle">
                  <input type="checkbox" class="checkbox" id="checkbox-3" />

                  <label for="checkbox-3" class="label">
                    <div class="ball"></div>
                  </label>
                </div>
                {/* End of toggle button  */}
              </div>
              <p className="text-white">
                These cookies may be set through our site by our advertising
                partners. They may be used by those companies to build a profile
                of your interests and show you relevant adverts on other sites.
                They do not store directly personal information but are based on
                uniquely identifying your browser and internet device. If you do
                not allow these cookies, you will experience less targeted
                advertising.
              </p>
            </li>
          </ul>
          <Link
            to="/"
            className="btn-white mt-10 inline-block uppercase tracking-wide"
          >
            Submit my preferences
          </Link>
        </div>
      </section>
    </>
  )
}
